import {createPerimeter} from 'vue-kindergarten';
import {indexOf, has, intersection, isEmpty} from 'lodash';

export default createPerimeter({
    purpose: 'permission',

    can: {
        accessWithAny(permissions) {
            return this.isSuperAdmin() || this.hasAny(permissions);
        }
    },

    isSuperAdmin() {
        return has(this.child, 'roles') && indexOf(this.child.roles, 'super_admin') !== -1
    },

    hasAny(permissions) {
        return has(this.child, 'permissions') && !isEmpty(intersection(permissions, this.child.permissions));
    }
});
